import { Component, Inject,Input , Output, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
//import _ from 'lodash';
import {_,moment} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext} from '../../interfaces/mysynch.interfaces';
@Component({
  standalone: false,
  selector: 'conception-dashboard',
  templateUrl: '../app/pages/conception-dashboard/conception-dashboard.view.html',
  styleUrls:['../app/pages/conception-dashboard/conception-dashboard.style.css']
})
export class ConceptionDashboard implements OnInit , OnDestroy {
     
    private performanceContext: PerformanceContext | null = null;
    // Code supporting the display of reasons for 403 when viewing dashboard
    private incompleteSetupMessage:string = '';
    
    private availableSwitchTypes:any = [];
    private availableLactationGroups:any = [];
  
    private reportRows:any = [];

  
    private switchTypeItemTmpl:object = {
        id: "",
        switchType: ""  
    }
   
    private lactationGroupItemTmpl:object = {
        id: "",
        lactGroup: ""
      
    }
    private concepDataTblItemTpl:object = {
        switchType:"",
        switchTypeDisplay:"",
        lactGroup: "",
        lactGripDisplay: "",
        codeDisplayColumnName: "",
        tableRows: []
    }
  
    private defaultSwitchType:string ="Month";
    private defaultLactationGroup:string ="All Cows (LACT>0)";
    private selectedSwitchTypes:any = [];
	private selectedLactationGroups:any = [];
    private csvIncludeList:string[] = [];

    // subscriptions and deregister functions
    private herdChangeSubscription: any;
  

    loading:boolean = true;
	allRows:any = [];
    dataUpdatedDate:any = null;
	isTotalRow:Function = this.rowIsTotal;
	isMobile:boolean = this.deviceDetector.isMobile();

    maskedSwitchTypes:string[] = ["Technician"];
    excludedColumnOneValues:string[] = ["OTHERS","TOTALS"];

    switchTypes:any = [];
    lactationGroups:any = [];
	concepDataTbls:any = [];
	initialSelectedSwitchTypes:any = []; 
	initialSelectedLactationGroups:any = []; 
	switchTypeSelectConfig:object = {
        controlId:"switchTypeSelect",
        labelProperty:"switchType",
        labelDisplayField:"switchType",
        valueKeyField:"switchType",
        orderByField:["switchType"],
        orderByDirection: ["asc"],
        placeholder: "Select Conception By",
        virtualScroll: true
     }		
     onSwitchTypeChange = (selSwitchTypes) => {
			
        this.selectedSwitchTypes = selSwitchTypes;
        
        this.buildReportData(this.selectedSwitchTypes,this.selectedLactationGroups);
    }

    onSwitchTypeAdd = (switchType) => {

    }

	lactationGroupSelectConfig:object = {
        controlId:"lactationGroupSelect",
        labelProperty:"groupMember",
        labelDisplayField:"groupMember",
        valueKeyField:"groupMember",
        orderByField:["sequence"],
        orderByDirection: ["asc"],
        placeholder: "Select Lactation Groups",
        virtualScroll: true
     }

    onLactationGroupChange = (lactationGroups) => {
        this.selectedLactationGroups = lactationGroups;
        this.buildReportData(this.selectedSwitchTypes,this.selectedLactationGroups);
    }
    onLactationGroupAdd = (lactationGroup) => {
        
    }
			

    _:any;

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(MySynchConstantService) private mySynchConstantService:MySynchConstantService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
                ){
                    this._ = _;

                }


			

    private formattedRate(rate) {
        return _.isNumber(rate) ? _.round(rate * 100, 1) + '%' : rate;
    }

    private formattedDecimal(val) {
        return (!_.isNumber(val) || _.isNaN(val)) ? val : _.round(val, 1);
    }

    private formatReportLineItems = (lineItems)=> {
        var columnOneValueColumn = _.trim(_.get(lineItems, 'columnOneValue'));
        var confInterval =   _.trim(_.get(lineItems,'cI_95_display',""));
        var conceptionRate = _.get(lineItems, 'concPerc', 0);
        var pregnancyCount = _.get(lineItems, 'pregCount', 0);
        var openCount = _.get(lineItems, 'openCount', 0);
        var otherCount = _.get(lineItems, 'otherCount', 0);
        var abortCount = _.get(lineItems, 'abortCount', 0);
        var totalCount = _.get(lineItems, 'totalCount', 0);
        var percentOfTotal = _.get(lineItems, 'totalPerc', 0);
        var servicesPerConception = _.get(lineItems, 'servicesPerConcep', 0);
        
        var switchType = _.get(lineItems,'switchType');
        var lactGroup = _.get(lineItems,'lactGroup');

        var formattedRowData = {
            columnOneValueColumn: columnOneValueColumn,
            confInterval: confInterval,
            conceptionRate: this.formattedRate(conceptionRate),
            pregnancyCount: pregnancyCount,
            openCount: openCount,
            otherCount: otherCount,
            abortCount: abortCount,
            totalCount: totalCount,
            percentOfTotal: this.formattedRate(percentOfTotal),
            servicesPerConception: this.formattedDecimal(servicesPerConception),
            switchType:switchType,
            lactGroup:lactGroup
        };

        return formattedRowData;
    }

    private rowIsTotal(row) {
        return row.columnOneValueColumn.toLowerCase() === 'totals';
    }

    private rowIsOther(row) {
        return row.columnOneValueColumn.toLowerCase() === 'others';
    }

    private buildFilterJSON(filterType,filterData){
        var filterDataJSON = "";
        var filterDataCollection = [];
        switch(filterType){
            case "conception-code":
                filterDataCollection = _.map(filterData, function filterToObject(filterDataItem){
                    // in SQL the codes match to a CsvFileType field and the SP is written to parse out csvFileType in the JSON data
                    return {switchType: filterDataItem};
                });
                break;
            case "lactation-group":
                filterDataCollection = _.map(filterData, function filterToObject(filterDataItem){
                    // in SQL the codes match to a CsvFileType field and the SP is written to parse out csvFileType in the JSON data
                    return {lactGroup: filterDataItem};
                });
                break;
        }

        var filterDataJSON = JSON.stringify(filterDataCollection);

        return filterDataJSON;
    }

    private getFilteredReportRows(switchType,lactGroup){
        
        return _.filter(this.allRows,{switchType:switchType,lactGroup:lactGroup});
    }

    private getOrderedLactationGroups(){   
        var allLactationGroups =  _.filter(_.get(this.MSF,'lists.groupTypeMembers',[]),{groupTypeCode:"LACTGROUP-SETCSV"});
        var uniqueLactationGroups = _.uniq(allLactationGroups,(lactationGroupItem)=>_.get(lactationGroupItem,"groupMember"));
        var orderedLactationGroups = _.sortBy(uniqueLactationGroups, (lactGroup)=>{
                                                                      // supplying a default value of 1.01 to avoid NaN. but lactGroup should always have a sequence
                                                                       var intDecimalSequence =   _.get(lactGroup,'sequence',1.01); 
                                                                        var decimalSequence = intDecimalSequence - Math.floor(intDecimalSequence);
                                                                        return decimalSequence;
                                                                    });      
        return orderedLactationGroups;
    }

    // cleans the selectedSwitchTypes of options no longer available
    private cleanSelectedSwitchTypes(){
        this.selectedSwitchTypes = _.filter(this.selectedSwitchTypes,(selectedSwitchType) => {
            var switchType = _.get(selectedSwitchType,'switchType');
            var switchTypeExists = _.includes(this.availableSwitchTypes,switchType);
            return switchTypeExists;
        });
    }
    // cleans the selectedLactationGroups of options no longer available
    private cleanSelectedLactationGroups(){
        this.selectedLactationGroups = _.filter(this.selectedLactationGroups,(selectedLactGrp)=> {
            var lactGroup = _.get(selectedLactGrp,'lactGroup');
            var lactGroupExists = _.includes(this.availableLactationGroups,lactGroup);
            return lactGroupExists;
        });
    }
    // maybe not be needed
    private intializeFilterDropdowns(){

        if(_.isEmpty(this.selectedSwitchTypes)){

            this.selectedSwitchTypes = _.filter(this.switchTypes,(switchType)=> {
                                            return _.isEqual(_.get(switchType,'switchType'),this.defaultSwitchType);						
                                        })
            this.initialSelectedSwitchTypes = _.filter(this.switchTypes,(switchType) => {
                                                    return _.isEqual(_.get(switchType,'switchType'),this.defaultSwitchType);						
                                                })
        }else{
            this.initialSelectedSwitchTypes = this.selectedSwitchTypes;
        }

        if(_.isEmpty(this.selectedLactationGroups)){
            this.selectedLactationGroups = _.filter(this.lactationGroups,(lactGroup) => {
                                            return _.isEqual(_.get(lactGroup,'lactGroup'),this.defaultLactationGroup);						
                                        })
            this.initialSelectedLactationGroups =  _.filter(this.lactationGroups,(lactGroup) => {
                                                    return _.isEqual(_.get(lactGroup,'lactGroup'),this.defaultLactationGroup);						
                                                })
        }else{
            this.initialSelectedLactationGroups = this.selectedLactationGroups;
        }
    }

    private loadFilterDropdowns(){
            // conception swticth types

            var csvFileLookups = _.get(this.MSF,"lists.csvFileLookup",[]);
    
            var switchTypes = []
            var switchTypeLookups = this._.uniq(_.map(csvFileLookups, (csvFileLookup) => { 
                return {csvFilename:_.get(csvFileLookup,'csvFilename'),
                        switchType:_.get(csvFileLookup,'switchType')
                       }
            }),(csvFileLookup) => _.get(csvFileLookup,'switchType'));

            _.forEach(switchTypeLookups,(switchTypeLookup)=>{
                var switchTypeDrpDwnItem = _.cloneDeep(this.switchTypeItemTmpl);   
            if(_.includes(this.availableSwitchTypes,_.get(switchTypeLookup,'switchType'))){
                
                _.set(switchTypeDrpDwnItem,'id',_.get(switchTypeLookup,'csvFilename'));  
                _.set(switchTypeDrpDwnItem,'switchType', _.get(switchTypeLookup,'switchType'))
                switchTypes.push(switchTypeDrpDwnItem);
            }
                
            });
            var orderedSwitchTypes = _.sortBy(switchTypes, 'switchType');
            this.switchTypes = _.cloneDeep(orderedSwitchTypes);
            if(_.isEmpty(this.selectedSwitchTypes)){
            this.initialSelectedSwitchTypes = _.filter(this.switchTypes,(switchType)=> {
                return _.isEqual(_.get(switchType,'switchType'),this.defaultSwitchType);						
            })
            // if the initial selected switch types is empty, set the selectedSwitchTypes to the first available switch type
            if(_.isEmpty(this.initialSelectedSwitchTypes) && !_.isEmpty(this.switchTypes)){
                this.initialSelectedSwitchTypes = [this.switchTypes[0]];
            }
            this.selectedSwitchTypes = _.cloneDeep(this.initialSelectedSwitchTypes);
            
            
        }else{
            this.initialSelectedSwitchTypes = this.selectedSwitchTypes;
        }

            // lactation groups

            var lactactionGroups = [];
            var lactactionGroupLookups = this._.uniq(_.map(csvFileLookups, (csvFileLookup) => {
                return {csvFilename:_.get(csvFileLookup,'csvFilename'),
                        lactGroup:_.get(csvFileLookup,'lactGroup')
                        }
                    }),(csvFileLookup) => _.get(csvFileLookup,'lactGroup'));	
            _.forEach(lactactionGroupLookups,(lactactionGroupLookup,index)=>{
                var lactGroupDrpDwnItem = _.cloneDeep(this.lactationGroupItemTmpl);   
            if(_.includes(this.availableLactationGroups,_.get(lactactionGroupLookup,'lactGroup'))){
                _.set(lactGroupDrpDwnItem,'id',_.get(lactactionGroupLookup,'lactGroup'));
                _.set(lactGroupDrpDwnItem,'lactGroup',_.get(lactactionGroupLookup,'lactGroup'));
                lactactionGroups.push(lactGroupDrpDwnItem);
            }
            });
           
            var orderedLacationGroups = this.getOrderedLactationGroups();
            this.lactationGroups = _.cloneDeep(orderedLacationGroups);
            if(_.isEmpty(this.selectedLactationGroups)){
            
            this.initialSelectedLactationGroups =  _.filter(this.lactationGroups,(lactGroup) => {
                return _.isEqual(_.get(lactGroup,'groupMember'),this.defaultLactationGroup);						
            })
            // if the initial selected lactation groups is empty, set the selectedLactationGroups to the first available lactation group
            if(_.isEmpty(this.initialSelectedLactationGroups) && !_.isEmpty(this.lactationGroups)){
                this.initialSelectedLactationGroups = [this.lactationGroups[0]];
            }
            this.selectedLactationGroups = _.cloneDeep(this.initialSelectedLactationGroups);
            
            
        }else{
            this.initialSelectedLactationGroups = this.selectedLactationGroups;
        }
    

    }

    private getDefaultSortedReportRows(reportRows){
        return _.sortBy(reportRows, (reportRow)=>{
           var columnOneValue =  _.get(reportRow,'columnOneValueColumn') as string;
            if(!_.isUndefined(columnOneValue)){
                return columnOneValue.toLowerCase();
            }else{
                // if the columnOneValue is undefined, return a sort result that makes all rows equallly sorted
                return 0;
            }
        });
    }

    private getSortedReportRowsBySwitchType(reportRows,switchType){
        var sortedReportRows = reportRows;

        var switchTypeCsvFileLookup = _.find(_.get(this.MSF,'lists.csvFileLookup',[]),{switchType:switchType});
        var switchTypeCsvFileLookupDetails = this.MSF.safeGetParsedJson(_.get(switchTypeCsvFileLookup,'detailsJson','{}'));
        // if the switchTypeCsvFileLookupDetails is empty, return the reportRows sorted by columnOneValue
        if(_.isEmpty(switchTypeCsvFileLookupDetails)){
            return this.getDefaultSortedReportRows(reportRows);
        }
        var sortDataType = _.get(switchTypeCsvFileLookupDetails[0],'codeColumnDataType',"string");
        
        // if the sortDataType is "custom" then we need to get the sortCode
        if(_.isEqual(sortDataType,"custom")){
            var sortCode = _.get(switchTypeCsvFileLookupDetails[0],'sortCode');
        }

        switch (sortDataType) {
            case "string":
                sortedReportRows = this.getDefaultSortedReportRows(reportRows);
                break;
            case "integer":
                sortedReportRows = _.sortBy(reportRows, (reportRow) =>{
                                        return _.parseInt(_.get(reportRow,'columnOneValueColumn'));
                                    });
                break;
            case "date":
                sortedReportRows = _.sortBy(reportRows,(reportRow)=>{
                                        return moment(_.get(reportRow,'columnOneValueColumn')).toDate();
                                    });
                break;
            case "custom":
                switch(sortCode){
                    case "BREEDCYCLE":
                        sortedReportRows = _.sortBy(reportRows, (reportRow)=>{
                                                 var columnOneValueDayRangeString = _.get(reportRow,'columnOneValueColumn') as string;
                                                 // get the number range portion of the string using regex where the number is can be in the forms of XXX and XXX-XXX
                                                 var numDaysRangeValues = columnOneValueDayRangeString.match(/\d+/g); // returns an array of numbers
                                                 // we'll order report rows by the start of the range
                                                 var rangeStart = _.parseInt(_.first(numDaysRangeValues));
                                                 return rangeStart;
                                            });
                        break;
                    case "DAYOFWEEK":
                        sortedReportRows = _.sortBy(reportRows, (reportRow) =>{
                                                 var msfWeekDayTypes = _.get(this.MSF,'lists.weekdayType',[]);
                                                 var rptRowDayOfWeek = _.get(reportRow,'columnOneValueColumn')  as string;
                                                 var weekDayType = _.find(msfWeekDayTypes,(weekDayType)=>_.isEqual(_.get(weekDayType,'name',"").toLowerCase(),rptRowDayOfWeek.toLowerCase()));                                                 
                                                 return _.get(weekDayType,'sequence');
                                            });
                        break;
                    default:
                        sortedReportRows = this.getDefaultSortedReportRows(reportRows);
                        break;
                }
                break;
        
            default:
                sortedReportRows = this.getDefaultSortedReportRows(reportRows);
                break;
        }
        return sortedReportRows;
    }

    private buildReportRowsBySwitchType(reportRows,switchType){

        var formattedRows = _.map(reportRows, this.formatReportLineItems);

        var othersRow = _.remove(formattedRows, this.rowIsOther);
        var totalRow = _.remove(formattedRows, this.rowIsTotal);

        var sortedRows = this.getSortedReportRowsBySwitchType(formattedRows,switchType);//_.sortBy(formattedRows, 'codeColumn');

        var organizedRows = sortedRows.concat(othersRow).concat(totalRow);

        return organizedRows;
    }

    private buildReportData(switchTypes,lactGroups){
        var filteredConcepDataTblItems = [];
            _.forEach(switchTypes,(switchTypeObj) =>{
                var switchType = _.get(switchTypeObj,'switchType');
                var filteredReportRowsBySwitchType = _.filter(this.allRows,{switchType:switchType});
                _.forEach(lactGroups,(lactGroupObj)=>{
                    var lactGroup = _.get(lactGroupObj,'groupMember');
                    var filteredReportRowsByLactGrp = _.filter(filteredReportRowsBySwitchType,{lactGroup:lactGroup});
                    if(!_.isEmpty(filteredReportRowsByLactGrp)){
                        var concepDataTblItem = _.cloneDeep(this.concepDataTblItemTpl);
                        _.set(concepDataTblItem,'switchType',switchType);
                        _.set(concepDataTblItem,'lactGroup',lactGroup);
                        var organizedFilteredReportRows = this.buildReportRowsBySwitchType(filteredReportRowsByLactGrp,switchType);
                        _.set(concepDataTblItem,'tableRows',organizedFilteredReportRows);
                        filteredConcepDataTblItems.push(concepDataTblItem);
                    
                    }
                });
            });

            this.concepDataTbls = filteredConcepDataTblItems;
    }
    
    private loadReportData() {
        return new Promise<void>((resolve, reject) => {
            // clearing previous report data
            this.loading = true;
            this.allRows = [];
            this.availableSwitchTypes = [];
            this.availableLactationGroups = [];
            this.reportRows = [];
            this.incompleteSetupMessage = '';

            var herdId = _.get(this.MSF.getActiveHerd(),"herdId");
            var herdKey = _.get(this.MSF.getActiveHerd(),"herdKey");
            
            
        
                
            this.perfMetricSvc.startTiming('Page:ConceptionDashboardPageData:Request');
            this.api.getHerdConcepDataBySwitchTypeAndHerdKey(herdId,herdKey,null,null, this.performanceContext, (err, results)=>{
                this.perfMetricSvc.endTiming("page",'Page:ConceptionDashboardPageData:Request', this.performanceContext);
                if (err) {
                    this.reportRows = [];
                    this.log.error('Error getting conception data: ' + err);

                    if (results.statusCode === 403) { // 403 indicates setup is not complete and should have display message in response
                        this.incompleteSetupMessage = results.statusText;
                    }

                    resolve(err); 
                }

                this.perfMetricSvc.startTiming('Page:ConceptionDashboard:Build');

                this.allRows = results;
                // we filter out rows of data for csvs that we don't want to show on this page
                this.allRows = _.filter(this.allRows,(row)=>_.includes(this.csvIncludeList,_.get(row,'csvFilename')));

                this.availableSwitchTypes = _.uniq(_.map(results, 'switchType'));
                this.availableLactationGroups = _.uniq(_.map(results, 'lactGroup'));
                
                // clean any selected conception or lactation groups that are no longer available
                this.cleanSelectedSwitchTypes();
                this.cleanSelectedLactationGroups();

                this.loadFilterDropdowns();
            
                
                this.buildReportData(this.selectedSwitchTypes,this.selectedLactationGroups);
            
                
                this.loading = false;
                
                // Have to use Jquery to click on the page title element to fix a dropdown loading issue
                this.MSF.waitForElm('#conceptionByDropdown').then( (result)=> {
                    $('#conceptionByDropdown').trigger('click');
                    console.log("page title clicked!!") 
                });
                this.perfMetricSvc.endTiming("page",'Page:ConceptionDashboard:Build', this.performanceContext);
                resolve();
            });
        });
    
    }

    disableDemoUserFilter(csvFileType,columnOneValue){
        var disable = false;
        // if the csvFileType is not one of the masked concep codes or the code is one of the excluded code values, disable the row
        if(!_.includes(this.maskedSwitchTypes,csvFileType) || _.includes(this.excludedColumnOneValues,columnOneValue)){
            disable = true;
        }
        return disable;
    }

    setupIsIncomplete(){
        return this.incompleteSetupMessage !== '';
    };
    getIncompleteSetupMessages() {
        return this.incompleteSetupMessage.split('|');
    };
    getTerritoryManager() {
        return this.MSF.getActiveFarmTerritoryManager();
    };

    ngOnDestroy(): void {
        if(this.herdChangeSubscription){
            this.herdChangeSubscription.unsubscribe();
        }

        // angular event handlers
        this.onSwitchTypeChange = null;
        this.onSwitchTypeAdd = null;
        this.onLactationGroupChange = null;
        this.onLactationGroupAdd = null;
        this.performanceContext = null;
    }

    ngOnInit() {
        this.MSF.ready(()=> {

            var concepDashCodeFileConfig = _.find(_.get(this.MSF,'lists.codeFile',[]),{codeType: "SITECONFIGS",code: "CONCEPTIONDASHBOARD"});
			this.csvIncludeList = _.get(this.MSF.safeGetParsedJson(_.get(concepDashCodeFileConfig,'detailsJson')),"[0].csvIncludeList");

            var currentActiveHerdId = _.get(this.MSF.getActiveHerd(), 'herdId') as number;
            var currentActiveHerdAdditionalHerdData = this.MSF.getAdditionalHerdDataItem(currentActiveHerdId);
            var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
            var metaDateFormat = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.dateFormat',this.mySynchConstantService.defaultShortDateFormat);
            var longDateFormat = this.MSF.getLongDateFormatFromMetaFormatString(metaDateFormat,"/");
            this.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(longDateFormat) : '';

            this.performanceContext = this.perfContextSvc.createPerformanceContext(currentActiveHerdId);
            this.perfMetricSvc.startTiming('Page:ConceptionDashboard:Render');
            this.loadReportData().then((result) => {
                this.perfMetricSvc.markPageReady('Page:ConceptionDashboard:Render', this.performanceContext);
            });

            this.herdChangeSubscription = this.mysynchDataStore.currentActiveHerd
            .subscribe((herd)=>{
                if(!_.isUndefined(herd) && this.loading === false){
                    var currrentActiveHerd = this.MSF.getActiveHerd();
                        if(!_.isUndefined(currrentActiveHerd) && !_.isNull(currrentActiveHerd) && !_.isEmpty(currrentActiveHerd)){
                            var currentActiveHerdId = _.get(currrentActiveHerd, 'herdId') as number;
                            var currentActiveHerdAdditionalHerdData = this.MSF.getAdditionalHerdDataItem(currentActiveHerdId);
                            var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
                            var metaDateFormat = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.dateFormat',this.mySynchConstantService.defaultShortDateFormat);
                            var longDateFormat = this.MSF.getLongDateFormatFromMetaFormatString(metaDateFormat,"/");
                            this.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(longDateFormat) : '';

                            this.perfMetricSvc.startTiming('Page:ConceptionDashboard:RenderOnHerdChange');
                            this.loadReportData().then((result) => {
                                this.perfMetricSvc.markPageReady('Page:ConceptionDashboard:RenderOnHerdChange', this.performanceContext);
                            })
                    }
                }
            });
        });
    }

   
		

}